"use strict";

window.addEventListener('DOMContentLoaded', function() {

    // --------------------------------------------------------------------------
    // 0. スクロールに合わせたヘッダー制御 & ナビ固定用の処理
    // --------------------------------------------------------------------------
    var headerEl = document.getElementById('shopify-section-header') 
                || document.getElementById('shopify-section-header-new')
                || document.querySelector('header')
                || document.querySelector('.header');
    var tabSystem = document.querySelector('.aglTravel__tab-system');

    if (headerEl && tabSystem) {
        var isStuck = false;
        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        tabSystem.parentNode.insertBefore(sentinel, tabSystem);

        var currentObserver = null;

        function setHeaderH(px) {
            document.documentElement.style.setProperty('--agl-header-h', px + 'px');
        }

        function initHeaderSticky() {
            if (currentObserver) currentObserver.disconnect();
            var h = headerEl.offsetHeight;
            if (!isStuck) setHeaderH(h);

            currentObserver = new IntersectionObserver(function (entries) {
                var entry = entries[0];
                var stuck = !entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight;
                if (stuck === isStuck) return;
                isStuck = stuck;
                if (stuck) {
                    headerEl.classList.add('agl-travel-header-hidden');
                    setHeaderH(0);
                } else {
                    headerEl.classList.remove('agl-travel-header-hidden');
                    setHeaderH(h);
                }
            }, {
                threshold: 0,
                rootMargin: '-' + h + 'px 0px 0px 0px'
            });

            currentObserver.observe(sentinel);
        }

        initHeaderSticky();
        window.addEventListener('resize', initHeaderSticky);
    }


    // --------------------------------------------------------------------------
    // 1. 日付表示処理
    // --------------------------------------------------------------------------
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth() + 1;
    const nowDate = now.getDate();
    const nowTxt = nowYear + "年" + nowMonth + "月" + nowDate + "日現在";
    const outputArea = document.getElementById("js-aglTravel__howto__now__ttl__date");
    if (outputArea) {
        outputArea.innerText = nowTxt;
    }


// --------------------------------------------------------------------------
    // 2. テーブル開閉制御（収支報告 - 開閉トグル完全対応版）
    // --------------------------------------------------------------------------
    const whiteOut = document.getElementById("js-aglTravel-whiteOut");
    const whiteOut_in = document.getElementById("js-aglTravel-whiteOut__in");
    const tableOpen = document.getElementById("js-aglTravel-tblOpen");
    const table = document.getElementById("js-aglTravel-tbl4c");

    if (table && whiteOut) {
        const rowCount = table.querySelectorAll("tbody tr").length;

        if (rowCount < 4) {
            whiteOut.classList.add("js-aglTravel-whiteOut--open");
            if (whiteOut_in) whiteOut_in.style.display = "none";
            if (tableOpen) tableOpen.style.display = "none";
        } else {
            if (tableOpen && whiteOut_in) {
                // テキスト部分を書き換えるための要素準備
                const circleHtml = '<div class="aglTravel-tblOpen__circle"></div>';

                tableOpen.addEventListener("click", function () {
                    const isOpen = whiteOut.classList.contains("js-aglTravel-whiteOut--open");

                    if (isOpen) {
                        // 【閉じる処理】
                        whiteOut.classList.remove("js-aglTravel-whiteOut--open");
                        whiteOut_in.classList.remove("js-aglTravel-whiteOut__in--open");
                        tableOpen.classList.remove("is-open");
                        // アイコンとテキストを「その他の期間の収支を見る」に戻す
                        tableOpen.innerHTML = circleHtml + "その他の期間の収支を見る";

                        // 閉じた位置へスクロール
                        const headerH = parseInt(document.documentElement.style.getPropertyValue('--agl-header-h')) || 0;
                        const tabNav = document.querySelector('.aglTravel__tab-nav');
                        const tabH = tabNav ? tabNav.offsetHeight : 0;
                        const targetPos = whiteOut.getBoundingClientRect().top + window.pageYOffset - tabH - headerH - 20;
                        window.scrollTo({ top: Math.max(0, targetPos), behavior: 'smooth' });

                    } else {
                        // 【開く処理】
                        whiteOut.classList.add("js-aglTravel-whiteOut--open");
                        whiteOut_in.classList.add("js-aglTravel-whiteOut__in--open");
                        tableOpen.classList.add("is-open");
                        // アイコンとテキストを「閉じる」に変更する
                        tableOpen.innerHTML = circleHtml + "閉じる";
                    }
                });
            }
        }
    }
    // --------------------------------------------------------------------------
    // 3. タブシステム制御＆スムーズスクロール
    // --------------------------------------------------------------------------
    var tabNav = document.querySelector('.aglTravel__tab-nav');
    var panels = document.querySelector('.aglTravel__panels');

    var map = {
        details:     ['angel-travel-details'],
        report:      ['angel-travel-report'],
        hotel:       ['angel-travel-hotel'],
        flow:        ['angel-travel-flow'],
        faq:         ['angel-travel-faq'],
        eligibility: ['angel-travel-flow'] // eligibility 指定で FLOW タブを開く
    };

    function scrollToTarget(targetEl) {
        if (!tabNav || !panels) return;
        var headerH = parseInt(document.documentElement.style.getPropertyValue('--agl-header-h')) || 0;
        var tabH = tabNav.offsetHeight;

        var baseTop = targetEl ? targetEl.getBoundingClientRect().top : panels.getBoundingClientRect().top;
        var targetPos = baseTop + window.pageYOffset - tabH - headerH;

        window.scrollTo({ top: Math.max(0, targetPos), behavior: 'smooth' });
    }

    function switchTab(key) {
        var ids = map[key];
        if (!ids) return false;
        ids.forEach(function (id) {
            var input = document.getElementById(id);
            if (input) input.checked = true;
        });
        return true;
    }

    // タブラベル（Tab 1〜5）クリック時
    if (tabNav && panels) {
        document.querySelectorAll('.aglTravel__tab-label').forEach(function (label) {
            label.addEventListener('click', function () {
                var targetId = label.getAttribute('for');
                if (targetId) {
                    var radio = document.getElementById(targetId);
                    if (radio) radio.checked = true;
                }
                scrollToTarget();
            });
        });
    }

    // 初回ロード時のURLハッシュ判定
    var initialKey = (location.hash || '').replace('#', '').toLowerCase();
    if (switchTab(initialKey)) {
        setTimeout(function() {
            var targetEl = initialKey ? document.getElementById(initialKey) : null;
            scrollToTarget(targetEl);
        }, 100);
    }

    // ページ内ハッシュ変更時
    window.addEventListener('hashchange', function () {
        var hashKey = (location.hash || '').replace('#', '').toLowerCase();
        if (switchTab(hashKey)) {
            setTimeout(function() {
                var targetEl = hashKey ? document.getElementById(hashKey) : null;
                scrollToTarget(targetEl);
            }, 100);
        }
    });

// --------------------------------------------------------------------------
    // 4. アンカーリンク / data-agl-tab のクリック制御（パネル切替同期版）
    // --------------------------------------------------------------------------
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="#"], [data-agl-tab]');
        if (!link) return;

        var href = link.getAttribute('href') || '';
        var key = link.dataset.aglTab;

        if (!key && href.includes('#')) {
            key = href.split('#')[1].toLowerCase();
        }

        if (key && map[key]) {
            e.preventDefault();

            // 1. まずラジオボタンを切り替える
            var isChanged = switchTab(key);

            // 2. 既にそのパネルが開いている場合はすぐにスクロール
            //    別のパネルから切り替える場合は、CSS描画が完了するまで150ms待つ
            var delay = 150; 

            setTimeout(function () {
                var targetEl = document.getElementById(key);
                
                // #eligibility の場合のフォールバック（要素取得補正）
                if (!targetEl && key === 'eligibility') {
                    targetEl = document.getElementById('eligibility') 
                            || document.querySelector('.aglTravel__panel--flow .aglTravel__eligibility')
                            || document.querySelector('.aglTravel__panel--flow');
                }

                if (targetEl) {
                    // ヘッダー＋固定タブの高さを差し引いたスクロール計算
                    var headerH = parseInt(document.documentElement.style.getPropertyValue('--agl-header-h')) || 0;
                    var tabH    = tabNav ? tabNav.offsetHeight : 0;
                    
                    var rect = targetEl.getBoundingClientRect();
                    var absoluteTop = rect.top + window.pageYOffset;
                    var goalPosition = absoluteTop - tabH - headerH;

                    window.scrollTo({
                        top: Math.max(0, goalPosition),
                        behavior: 'smooth'
                    });
                }
            }, delay);
        }
    });});


// --------------------------------------------------------------------------
// 5. Swiper初期化関数
// --------------------------------------------------------------------------
function initSwiper() {
    const sliderEl = document.querySelector("#js-agl-travel__slider__in");
    
    if (sliderEl && typeof Swiper !== 'undefined') {
        new Swiper(sliderEl, {
            loop: true,
            speed: 8000,
            spaceBetween: 10,
            slidesPerView: 3.8,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwiper);
} else {
    initSwiper();
}